import React from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  id: 1,
  name: 'María L.',
  time: '14:30',
  message: '¡Hola! Quería contarles que ayer vendí mis primeras 20 viandas. No lo puedo creer, ¡gracias por el curso! 🥰🍲'
}, {
  id: 2,
  name: 'Sofía R.',
  time: '16:45',
  message: 'Chicas, el finde tuve mi primer Candy Bar para un cumple de 15. Quedaron fascinados y ya me pidieron presupuesto para otro evento. 🎉✨'
}, {
  id: 3,
  name: 'Carolina M.',
  time: '10:15',
  message: 'Empecé con las palomitas gourmet hace un mes y ya estoy abasteciendo a 3 dietéticas del barrio. Es súper rentable. 🍿📈'
}];
const galleryImages = ['https://cdn.magicpatterns.com/uploads/cx49UkW6LanwoBFnQpDJWL/Captura_de_pantalla_2026-04-30_a_las_9.02.10_p._m..png', 'https://cdn.magicpatterns.com/uploads/xxuZDmH6paWt4oBkbvU5Gv/Captura_de_pantalla_2026-05-01_a_las_1.28.40_a._m..png', 'https://cdn.magicpatterns.com/uploads/bsUHV7bHDmDs9RpqAY7xZZ/ChatGPT_Image_24_feb_2026_23_42_26.png', 'https://cdn.magicpatterns.com/uploads/r516A9f8cFr7FgSvUnaFQ5/mockupfondoblancoheylloyd-image-1771971820625.png'];
export function SocialProof() {
  return <section className="py-24 bg-white overflow-hidden" data-id="element-84">
      <div className="container mx-auto px-6 md:px-12" data-id="element-85">
        <div className="text-center mb-16" data-id="element-86">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-serif font-bold text-stone-800 mb-4" data-id="element-87">
            Resultados reales de personas que empezaron desde cero
          </motion.h2>
          <motion.div initial={{
          opacity: 0,
          width: 0
        }} whileInView={{
          opacity: 1,
          width: '60px'
        }} viewport={{
          once: true
        }} className="h-1 bg-[#C9A96E] mx-auto rounded-full" data-id="element-88" />
        </div>

        <div className="max-w-4xl mx-auto mb-20" data-id="element-89">
          <div className="bg-[#E5DDD5] p-6 md:p-10 rounded-3xl shadow-inner relative" data-id="element-90">
            {/* Chat background pattern overlay could go here, keeping it clean for now */}
            <div className="space-y-6" data-id="element-91">
              {testimonials.map((t, index) => <motion.div key={t.id} initial={{
              opacity: 0,
              x: index % 2 === 0 ? -20 : 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.2,
              duration: 0.5
            }} className={`flex ${index % 2 === 0 ? 'justify-start' : 'justify-end'}`} data-id="element-92">
                  <div className={`max-w-[85%] md:max-w-[70%] rounded-2xl px-5 py-4 shadow-sm relative ${index % 2 === 0 ? 'bg-white rounded-tl-none' : 'bg-[#DCF8C6] rounded-tr-none'}`} data-id="element-93">
                    <div className="flex justify-between items-baseline mb-1" data-id="element-94">
                      <span className="font-semibold text-sm text-stone-700" data-id="element-95">
                        {t.name}
                      </span>
                      <span className="text-[11px] text-stone-500 ml-4" data-id="element-96">
                        {t.time}
                      </span>
                    </div>
                    <p className="text-stone-800 text-[15px] leading-relaxed" data-id="element-97">
                      {t.message}
                    </p>
                  </div>
                </motion.div>)}
            </div>
          </div>
        </div>

        {/* Mini Gallery */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-5xl mx-auto" data-id="element-98">
          {galleryImages.map((img, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.4
        }} className="aspect-square rounded-2xl overflow-hidden shadow-md" data-id="element-99">
              <img src={img} alt="Resultados" className="w-full h-full object-cover hover:scale-110 transition-transform duration-500" data-id="element-100" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}